import React from 'react'

import { loggedIn } from '~/common/server/loggedIn'
import LoginLayoutPage from '~/components/page/login/LoginLayoutPage'

const Page = () => {
  return (
    <LoginLayoutPage/>
  )
}

export const getServerSideProps = loggedIn

export default Page
